import React, { useContext } from "react";
import PropTypes from "prop-types";
import Drawer from "@material-ui/core/Drawer";
import { SIAANestedList } from "./SIAANestedList";
import { UserContext } from "../UserContext";
import { DonnaNestedList } from "./DonnaNestedList";

const ANCHOR = "left";

export function DrawerMenu(props) {
  const { open, onClose, doesNotHaveTenant } = props;
  const { user } = useContext(UserContext);
  const isSiaaAgency = user.isSiaaAgency();
  return (
    <Drawer anchor={ANCHOR} open={open} onClose={onClose}>
      {isSiaaAgency ? (
        <SIAANestedList
          onClose={onClose}
          doesNotHaveTenant={doesNotHaveTenant}
        />
      ) : (
        <DonnaNestedList
          onClose={onClose}
          doesNotHaveTenant={doesNotHaveTenant}
        />
      )}
    </Drawer>
  );
}

DrawerMenu.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};
